/* eslint-disable camelcase */
import React from 'react';
import { InputLabel } from '@material-ui/core';
import { Mutation } from '@apollo/client/react/components';
import DrawerNative from '../DrawerNative';
import { ADD_CATEGORY } from '../../queries/category';
import FormCategory from './FormCategory';
import useStyles from './styles';

export const AddCategories = ({ siteDomain, setSiteDomain }) => {
  const classes = useStyles();
  return (
    <>
      <InputLabel className={classes.labelCenter}>New category</InputLabel>
      <DrawerNative
        title="New category"
        disabled={!siteDomain}
        labelButtonAction="Add"
      >
        <Mutation mutation={ADD_CATEGORY}>
          {(mutationAddCategory) => (
            <FormCategory
              mutationAddCategory={mutationAddCategory}
              siteDomain={siteDomain}
              setSiteDomain={setSiteDomain}
            />
          )}
        </Mutation>
      </DrawerNative>
    </>
  );
};
